import { Playground, Props } from 'docz';
import { Input, Button } from "../../../../../src";
import * as React from 'react';
export default {
  Playground,
  Props,
  Input,
  Button,
  React
};